const oakScreens = [
  {
    id: "oak-system-overview",
    kind: "desktop",
    slot: "desktop",
    src: "/images/cooperators/case-studies/oak/system-overview.webp",
    alt: "Oak design system overview with entry points for design, development, and change history",
    caption: "One system connecting design, development, and ongoing support",
    frame: {
      x: 3,
      y: 3,
      width: 84,
      height: 82,
      rotation: 0,
      zIndex: 1,
      cropX: 50,
      cropY: 18,
    },
  },
  {
    id: "oak-component-library",
    kind: "desktop",
    slot: "tertiary",
    src: "/images/cooperators/case-studies/oak/component-library.webp",
    alt: "Oak component library organized into reusable interface components and patterns",
    caption: "A shared component foundation for recurring enterprise needs",
    frame: {
      x: 29,
      y: 31,
      width: 58,
      height: 67,
      rotation: 0,
      zIndex: 3,
      cropX: 50,
      cropY: 9,
    },
  },
  {
    id: "oak-button-api",
    kind: "desktop",
    slot: "primary",
    src: "/images/cooperators/case-studies/oak/button-api.webp",
    alt: "Oak button documentation showing implementation options and API guidance",
    caption: "Implementation guidance connected component intent to code",
    frame: {
      x: 72,
      y: 20,
      width: 26,
      height: 76,
      rotation: 3,
      zIndex: 4,
      cropX: 50,
      cropY: 8,
    },
  },
];

export const oakDesignDevelopmentGallery = [
  {
    id: "oak-designer-resources",
    src: "/images/cooperators/case-studies/oak/designer-resources.webp",
    alt: "Oak design guidance with onboarding resources and shared UI kits for designers",
    caption: "Design resources aligned teams before detailed product work began",
  },
  {
    id: "oak-developer-setup",
    src: "/images/cooperators/case-studies/oak/developer-setup.webp",
    alt: "Oak developer documentation covering repositories, supported frameworks, and implementation setup",
    caption: "Developer guidance supported adoption across React, Vue, and Angular",
  },
];

export const oakComponentProductGallery = [
  {
    id: "oak-button-accessibility",
    src: "/images/cooperators/case-studies/oak/button-accessibility.webp",
    alt: "Oak button accessibility guidance for labels, keyboard interaction, and colour use",
    caption: "Accessibility requirements were documented with the component",
  },
  {
    id: "oak-button-variants",
    src: "/images/cooperators/case-studies/oak/button-variants.webp",
    alt: "Oak button variants showing icons, links, states, and loading behaviour",
    caption: "Variants addressed real interaction needs without fragmenting the system",
  },
  {
    id: "oak-in-client-portal",
    src: "/images/cooperators/case-studies/client-portal/evidence/add-driver-desktop.webp",
    alt: "Co-operators client portal add-driver journey built with Oak patterns on desktop",
    caption: "Oak operating inside a complex authenticated product journey",
  },
];

export const oakGovernanceGallery = [
  {
    id: "oak-roadmap",
    src: "/images/cooperators/case-studies/oak/roadmap.webp",
    alt: "Oak roadmap documenting planned components and future system improvements",
    caption: "A visible roadmap connected system priorities to product needs",
  },
  {
    id: "oak-changelog",
    src: "/images/cooperators/case-studies/oak/changelog.webp",
    alt: "Oak changelog documenting releases, component updates, and version history",
    caption: "Version history made ongoing change clear and manageable",
  },
];

export default oakScreens;
